<!-- <div class="container">
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h2 class="text-center">Offline Payment Mode: Upload Check</h2>
        
        <p>Thank you for choosing our offline payment option. We understand that sometimes it's more convenient to make payments through traditional methods. To proceed with the offline payment mode, please follow the instructions below to upload your check securely.</p>
        
        <div class="step">
          <h3>Step 1: Prepare Your Check</h3>
          <ol>
            <li>Ensure that you have a physical check issued by your bank or financial institution.</li>
            <li>Fill out the check with the correct payment amount, date, and payee details.</li>
            <li>Double-check all the information on the check to avoid any errors or discrepancies.</li>
          </ol>
        </div>
        
        <div class="step">
          <h3>Step 2: Scan or Photograph Your Check</h3>
          <ol>
            <li>Place your check on a flat surface with good lighting.</li>
            <li>If you have access to a scanner, scan both sides of the check in high resolution, preferably in PDF format.</li>
            <li>If you don't have a scanner, use your smartphone or digital camera to take clear, well-lit photographs of both sides of the check. Make sure all the details are visible and legible.</li>
          </ol>
        </div>
        
        <div class="step">
          <h3>Step 3: Upload Your Check</h3>
          <ol>
            <li>
                Upload your check:
                <input type="file" name="image" ng2FileSelect  #fileInput [uploader]="uploader" accept="text/plain" />
                <button *ngIf="!success" class="fa fa-upload" (click)="uploader.uploadAll()">upload</button> <i *ngIf="success" class="fa fa-check-circle" style="font-size:30px;color:green"></i>
                <div class="upload-icon" (click)="fileInput.click()"></div>
                <div class="error-message" *ngIf="!isFileSelected" style="color: red;">Please select a file</div>
                <small class="form-text text-muted">Accepted formats: JPEG, PNG, PDF</small>
            </li>
          </ol>
        </div>
        
        <div class="step">
          <h3>Step 4: Confirmation and Processing</h3>
          <ol>
            <li>After uploading the check, you will receive a confirmation message on your registered email. This confirms that we have received your payment details.</li>
            <li>Our team will manually process the check and verify the information provided.</li>
            <li>Please note that processing times may vary, but we strive to complete the verification process within 7 business days.</li>
            <li>Once the check is verified, your payment will be processed, and you will receive a notification confirming the successful payment.</li>
          </ol>
        </div>
        
        <div class="important-reminders">
          <h3>Important Reminders:</h3>
          <ol>
            <li>Keep the physical check in a safe place until the payment is fully processed.</li>
            <li>Do not attempt to deposit or cash the check again to avoid any potential duplicate payments.</li>
            <li>In case of any issues or inquiries regarding your offline payment, please contact our customer support team. Provide them with relevant information, such as the check number, payment date, and any other details that may assist them in resolving the matter promptly.</li>
          </ol>
        </div>
        
        <p class="text-center">We appreciate your trust in our services and your cooperation in making the payment via the offline mode. If you have any further questions or concerns, please don't hesitate to reach out to our dedicated customer support team.</p>
      </div>
    </div>
    <div class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2">
            <button (click)="upload()">SUBMIT</button>
        </div>
    </div>
  </div> -->
  <div class="container">
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h2 class="text-center">Offline Payment Mode: Upload UTR Number</h2>
  
        <p>Thank you for choosing our offline payment option. We understand that sometimes it's more convenient to make payments through traditional methods. To proceed with the offline payment mode, please follow the instructions below to upload your UTR number securely.</p>
        <div class="step">
            <h3>Step 1: Download Proforma Invoice</h3>
            <p>Before proceeding with the payment, you can download the proforma invoice by clicking the button below.</p>
            <button class="btn btn-primary" (click)="downloadInvoice()">Download Proforma Invoice</button>
          </div>
          <br>
        <div class="step">
          <h3>Step 2: Initiate Payment</h3>
          <p>Complete the payment through an offline method, such as bank transfer or direct deposit.</p>
          <p>Ensure that you receive a Unique Transaction Reference (UTR) number from your bank after making the payment.</p>
        </div>
  
        <div class="step">
          <h3>Step 3: Provide UTR Number</h3>
          <input type="text" #utrNumber placeholder="Enter UTR Number"  style="width:50%" required> &nbsp;&nbsp; <button *ngIf="!success" (click)="updateUTRNumber()">Submit</button><i *ngIf="success" class="fa fa-check-circle" style="font-size:30px;color:green"></i>
          <br>
          <div class="error-message" *ngIf="!isUTRUpdated" style="color: red;">Please Enter UTR Number</div>
        </div>
  <br>
        <div class="step">
          <h3>Step 4: Verification and Confirmation</h3>
          <p>After providing the UTR number, our system will verify the payment details and match them with the corresponding transaction.</p>
          <p>Once the UTR number is successfully validated, you will receive a confirmation message indicating that your payment has been received.</p>
        </div>
  
        <div class="important-reminders">
          <h3>Important Reminders:</h3>
          <ol>
            <li>Keep a record of the UTR number for your reference and future inquiries.</li>
            <li>Avoid sharing your UTR number with unauthorized individuals to ensure the security of your payment.</li>
            <li>In case of any issues or inquiries regarding your offline payment or UTR number, please contact our customer support team. Provide them with relevant information to help resolve the matter promptly.</li>
          </ol>
        </div>
  
        <p class="text-center">We appreciate your trust in our services and your cooperation in providing the UTR number for the offline payment. If you have any further questions or concerns, please don't hesitate to reach out to our dedicated customer support team.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
      </div>
      <div class="col-md-2">
        <button (click)="upload()">SUBMIT</button>
      </div>
    </div>
  </div>
  
  